import { Route, Routes } from "react-router-dom";

import { SelectorsScreen } from "./";
import { EditSelector } from "./edit/EditSelector";
import { NewSelector } from "./edit/NewSelector";

export const SelectorsRouter = () => {
  return (
    <Routes>
      <Route path="new" element={<NewSelector />} />
      <Route path=":selectorId" element={<EditSelector />} />
      <Route path="*" element={<SelectorsScreen />} />
    </Routes>
  );
};
